import intruction1 from "./intruction1.jpg";
import intruction2 from "./intruction2.jpg";
import sub1act2_01 from "./sub1act2_01.jpg";
import sub1act2_02 from "./sub1act2_02.jpg";
import sub1act2_03 from "./sub1act2_03.jpg";
import sub2act1_01 from "./sub2act101.jpg";
import sub2act1_02 from "./sub2act102.jpg";
import sub2act1_03 from "./sub2act103.jpg";
import sub2_act_2_01 from "./sub2_act_2_01.jpg";
import sub2_act_2_02 from "./sub2_act_2_02.jpg";
import sub3_act_1_01 from "./sub3_act_1_01.jpg";
import sub3_act_1_02 from "./sub3_act_1_02.jpg";
import sub3_act_1_03 from "./sub3_act_1_03.jpg";
import sub4_act_1_01 from "./sub4_act_1_01.jpg";
import sub4_act_1_02 from "./sub4_act_1_02.jpg";
import sub4_act_2_01 from "./sub4_act_2_01.jpg";
import sub4_act_2_02 from "./sub4_act_2_02.jpg";
import sub5_act_1_01 from "./sub5_act_1_01.jpg";
import sub5_act_1_02 from "./sub5_act_1_02.jpg";
import sub6_act_1_01 from "./sub6_act_1_01.jpg";
import sub1_act_3_01 from "./sub1_act_3_01.jpg";
import sub1_act_3_02 from "./sub1_act_3_02.jpg";
import sub1_act_3_001 from "./sub1_act_3_001.png";

export const imgInstruction = {
	intruction1,
	intruction2,
	sub1act2_01,
	sub1act2_02,
	sub1act2_03,
	sub2act1_01,
	sub2act1_02,
	sub2act1_03,
	sub2_act_2_01,
	sub2_act_2_02,
	sub3_act_1_01,
	sub3_act_1_02,
	sub3_act_1_03,
	sub4_act_1_01,
	sub4_act_1_02,
	sub4_act_2_01,
	sub4_act_2_02,
	sub5_act_1_01,
	sub5_act_1_02,
	sub6_act_1_01,
	sub1_act_3_01,
	sub1_act_3_02,
	sub1_act_3_001
};
